// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotificationsIcon_wrapper__1iW7J","indicator":"NotificationsIcon_indicator__1uwWD"};